// =============================================================================
// App
// =============================================================================

// Global
// =============================================================================
import './global/body';

// Import
// =============================================================================
import 'owl.carousel';
import 'lity';

// Partials
// =============================================================================
import './partials/site-header';

// Menus
// =============================================================================
import './menus/header-menu';

// Components
// =============================================================================
import './components/hero';
import './components/global-banner';
import './components/slide-text';
import './components/slide-boxes';
import './components/testimonials';
import './components/wheel';
import './components/wheel-numbered';
import './components/wheel360';
import './components/values';
import './components/team';
import './components/accordion';
import './components/locations';
import './components/location-contacts';

// Fuctions
// =============================================================================
import './functions/animations';

// Misc
// =============================================================================
//import './misc/particles';
//import './misc/particles-app';

// Constants
// =============================================================================

const $body = $('body');
const $window = $(window);
const $document = $(document);

// Document Ready
// =============================================================================

// Window Ready
// =============================================================================

$window.on('load', () => {
    // ...
    $('.owl-carousel').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 3,
            },
            1000: {
                items: 5,
            },
        },
    });
});
